var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"suggestion"},[_vm._v(" Did you mean: "),_c('a',{on:{"click":function($event){return _vm.emitSuggestion()}}},[_vm._v(_vm._s(_vm.suggestion))]),_vm._v("? ")])}
var staticRenderFns = []

export { render, staticRenderFns }